<automata-product-activation-panel
  #commonProductPanel
  [triggerChoices]="triggerChoices"
  [taskDefinitionId]="taskDefinitionId"
  [automation]="automation"
  [compareRejectedReason]="false"
  [includeTrialSelection]="false"
  [descriptionTranslationId]="'AUTOMATIONS.EDITOR.TRIGGERS.PRODUCT_ACTIVATION.PRODUCT_DEACTIVATED.PRODUCT_DEACTIVATED'"
></automata-product-activation-panel>
